<div class="modal-header">
    <h4 class="modal-title">Detalles del usuario</h4>
    <button
        type="button"
        class="btn-close"
        aria-label="Cerrar"
        (click)="cerrar()"></button>
</div>

<div class="modal-body">
    <dl class="row mb-0">
        <dt class="col-sm-4">Usuario:</dt>
        <dd class="col-sm-8">{{ usuario.username || 'N/A' }}</dd>

        <dt class="col-sm-4">Nombre completo:</dt>
        <dd class="col-sm-8">{{ nombreCompleto || 'N/A' }}</dd>

        <dt class="col-sm-4">Correo electrónico:</dt>
        <dd class="col-sm-8">{{ usuario.correo || 'N/A' }}</dd>

        <dt class="col-sm-4">Estado:</dt>
        <dd class="col-sm-8">{{ usuario.estado ? 'Activo' : 'Inactivo' }}</dd>

        <dt class="col-sm-4">Cargo:</dt>
        <dd class="col-sm-8">{{ usuario.cargo || 'N/A' }}</dd>

        <dt class="col-sm-4">Teléfono:</dt>
        <dd class="col-sm-8">{{ usuario.telefono || 'N/A' }}</dd>

        <dt class="col-sm-4">Rol:</dt>
        <dd class="col-sm-8">{{ nombresRoles }}</dd>

        <dt class="col-sm-4">Entidad:</dt>
        <dd class="col-sm-8">{{ usuario.entidad || 'N/A' }}</dd>

        <dt class="col-sm-4">Fecha de inactivación:</dt>
        <dd class="col-sm-8">
            {{
                usuario.fechaInactivacion
                    ? (usuario.fechaInactivacion | date: 'dd/MM/yyyy')
                    : 'N/A'
            }}
        </dd>

        <dt class="col-sm-4">Fecha estimada de inactivación:</dt>
        <dd class="col-sm-8">
            {{
                usuario.fechaInactivacion 
                    ? 'N/A'
                    : fechaEstimadaInactivacion 
                        ? (fechaEstimadaInactivacion | date: 'dd/MM/yyyy':'UTC')
                        : 'N/A'

            }}
        </dd>
    </dl>
</div>

<div class="modal-footer">
    <button
        type="button"
        class="btn btn-outline-secondary btn-cerrar"
        (click)="cerrar()">
        Cerrar
    </button>
</div>
